import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Slider } from './ui/slider';
import { Layers } from 'lucide-react';

export default function InfillControl({ infill, onInfillChange }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Layers className="w-5 h-5" />
          Infill (Fülldichte)
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <label className="text-sm font-medium mb-2 block text-gray-900">
            Infill: {infill.toFixed(0)}%
          </label>
          <Slider
            value={[infill]}
            onValueChange={([value]) => onInfillChange(value)}
            max={100}
            min={10}
            step={5}
            className="w-full"
          />
        </div>
        <div className="text-sm text-gray-600">
          <p>Je höher die Fülldichte, desto stabiler und schwerer wird das Bauteil.</p>
        </div>
      </CardContent>
    </Card>
  );
}
